// extracted by mini-css-extract-plugin
export default {"eventDateContainer":"SNUL3VxsmEKJty3PVDcH","calendarIcon":"CWr3umlB4IlHOr9aUT4B"};